import type { CatalogLink } from "@ext/navigation/NavigationLinks";
import type { Dispatch, SetStateAction } from "react";
import type { HomeFolder } from "../utils/homeLayoutTypes";
import FolderPage from "./FolderPage";

interface FolderDraftViewProps {
	folder: HomeFolder;
	linkByName: Record<string, CatalogLink>;
	setIsAnyCardLoading: Dispatch<SetStateAction<boolean>>;
	editMode?: boolean;
	onBack: () => void;
	onRemoveFromFolder?: (catalogName: string) => void;
	onReorder?: (newOrder: string[]) => void;
}

const FolderDraftView = ({
	folder,
	linkByName,
	setIsAnyCardLoading,
	editMode,
	onBack,
	onRemoveFromFolder,
	onReorder,
}: FolderDraftViewProps) => (
	<FolderPage
		editMode={editMode}
		items={folder.items}
		linkByName={linkByName}
		onBack={onBack}
		onRemoveFromFolder={onRemoveFromFolder}
		onReorder={onReorder}
		setIsAnyCardLoading={setIsAnyCardLoading}
		title={folder.title}
	/>
);

export default FolderDraftView;
